/* eslint-disable react/state-in-constructor */
import React from 'react';
import { memoize } from 'lodash';
import YCApi from '../../services/ycApi';

const api = new YCApi();
const getOptionsData = memoize(() =>
  api.fetchOptionsList().then(response => response.data)
);

export default Component =>
  class extends React.Component {
    state = {
      optionsData: {}
    };

    componentDidMount() {
      getOptionsData().then(optionsData => {
        this.setState({ optionsData });
      });
    }

    render() {
      const { optionsData } = this.state;
      return <Component {...this.props} optionsData={optionsData} />;
    }
  };
